import React from 'react';
import { notable } from '../mock';
import SectionHeader from './SectionHeader';

export default function Notable() {
  return (
    <section className="py-20 md:py-28 border-t border-neutral-900">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionHeader
          kicker={notable.kicker}
          title={notable.title}
          description={notable.description}
        />

        <div className="divide-y divide-neutral-900 border-y border-neutral-900">
          {notable.items.map((it) => (
            <div
              key={it.n}
              className="py-7 md:py-9 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-10 group hover:bg-[#0d0d0d] transition-colors px-2 md:px-4"
            >
              <p className="md:col-span-2 mono text-[11px] tracking-[0.22em] text-neutral-500">
                {`${it.n} · ${it.tag}`}
              </p>
              <h3 className="md:col-span-5 font-display text-white text-[24px] md:text-[30px] leading-[1.05] group-hover:text-[#ED2D5C] transition-colors">
                {it.title}
              </h3>
              <p className="md:col-span-5 text-neutral-400 text-[14px] md:text-[15px] leading-relaxed">
                {it.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
